import constants from "constants/constants";
import { roundOffIfDecimal } from "features/Common/modules/DataTypes/utils/numbers";
import { isInternationalTimezone } from "utils/AuthUtil";
import {
  ROUNDOFF_UPTO,
  validateAmountRegex,
  validateNumberRegex,
  WALLET_BALANCE_NIL,
  WALLET_SETTING_KEYS,
} from "../constants/Wallets.constants";

export const getAmountWithCurrenyString = (balance) => {
  return `${
    !isInternationalTimezone() ? constants.inr_currency : constants.usd_currency
  } ${
    balance || balance == WALLET_BALANCE_NIL
      ? roundOffIfDecimal(parseFloat(balance), ROUNDOFF_UPTO)
      : ""
  }`;
};

export const shouldIncludeSubSection = ({
  subSectionKey,
  automatedPayoutToggle,
  automatedTopupToggle,
}) => {
  if (subSectionKey === WALLET_SETTING_KEYS.AUOMATED_PAYOUT_ADD_DETAILS) {
    return automatedPayoutToggle;
  }

  if (subSectionKey === WALLET_SETTING_KEYS.AUOMATED_TOPUP_ADD_DETAILS) {
    return automatedTopupToggle;
  }

  return true;
};

export const validateAmountField = (value) => {
  let isValid = true;
  if (value < 0) {
    isValid = false;
  }
  if (new RegExp(validateAmountRegex).test(value)) {
    isValid = false;
  }

  return isValid;
};
export const validateCustomDaysField = (value) => {
  let isValid = true;
  if (parseInt(value) < 0) {
    isValid = false;
  }
  if (new RegExp(validateNumberRegex).test(value)) {
    isValid = false;
  }

  return isValid;
};
